<template>
  <div>
    <h1>Carga y descarga</h1>
    <p>Aquí irá el módulo de carga y descarga.</p>
  </div>
</template>

<script>
export default {
  name: 'CargaDescarga'
}
</script>